import { render, staticRenderFns } from "./Productsbodyone.vue?vue&type=template&id=07e89570&"
import script from "./Productsbodyone.vue?vue&type=script&lang=js&"
export * from "./Productsbodyone.vue?vue&type=script&lang=js&"
import style0 from "./Productsbodyone.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports